import { VideoResponse } from '@/types/cms';
import {  DurationRuntime } from './duration-time-formatter';
import { formatLongRunningDate } from './date-formatter';

export class VideoFormatter {

  
  static getRenderedEpisodeNumbering(video: VideoResponse): string | undefined {
    switch (video.renderType) {
      case 'EPISODIC':
      case 'BOXSET':
        return VideoFormatter.getSeasonAndEpisodeNumber(video);
      case 'STAND_ALONE':
        return undefined;
      case 'LONG_RUNNING':
        return formatLongRunningDate(video.airDate);
    }
  }
  
  
  static getRenderedEpisodeNumberingWithDuration(video: VideoResponse): string | undefined {
    const duration = VideoFormatter.getDurationRuntimeString(video);
  
    const parts = [VideoFormatter.getRenderedEpisodeNumbering(video), duration].filter(
      (part): part is string => part !== undefined && part !== ''
    );
  
    return parts.length > 0 ? parts.join(' - ') : undefined;
  }
  


  private static getSeasonAndEpisodeNumber(video: VideoResponse): string | undefined {
    let value = '';

    if (video.seasonNumber !== null && video.seasonNumber !== undefined) {
      value = `S${video.seasonNumber}`;
    }

    if (video.episodeNumber !== null && video.episodeNumber !== undefined) {
      if (value === '') {
        value = `E${video.episodeNumber}`;
      } else {
        value = `${value} E${video.episodeNumber}`;
      }
    }

    return value === '' ? undefined : value;
  }

    
    static getEpisodeCellSubtitle(video: VideoResponse): string | undefined {
        if (video.displayTitle) {
            return video.displayTitle;
        }
        return VideoFormatter.getRenderedEpisodeNumbering(video);
    }
    
   
    
    //Used in BCOV to update the name and moving to new episode on auto play
    //Ros na Run: S1-E4
    //Nuacht: 05/09/1991
    //Laochra Gael: (displayName)
    static getRenderedCompleteTitle(video: VideoResponse): string {
        
        let result: string = "";
        if (video.seriesTitle) {
            result = video.seriesTitle;
        }
        
        let secondPart: string | undefined;
        if (video.displayTitle) {
            secondPart = video.displayTitle;
        } else {
            secondPart = VideoFormatter.getRenderedEpisodeNumbering(video);
        }
        
        if (secondPart) {
            if (result === "") {
                result = secondPart;
            } else {
                result = `${result}: ${secondPart}`;
            }
        }
        
        return result
    }
    
    static getRenderedSeriesTitleAndDisplayTitle(video: VideoResponse): string | undefined {
        
        let result: string = "";
        if (video.seriesTitle) {
            result = video.seriesTitle;
        }
        
        if (video.displayTitle) {
            if (result === "") {
                result = video.displayTitle;
            } else {
                result = `${result}: ${video.displayTitle}`;
            }
        }
        
        return result === "" ? undefined : result;
        
    }
    
    static getDurationRuntimeString(video: VideoResponse): string | undefined {
      const duration = video.duration === null ? undefined : DurationRuntime(video.duration);
      return duration;
    }

}
